module.exports = __webpack_public_path__ + "img/wz_head.ce8d8b09.png";